const calculatedEvents = {
  late: 'late',
  mayBeMissing: 'may_be_missing',
};

export default calculatedEvents;
